/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { DownloadCardFragment } from "@cosmos/hygraph-schema";

import { TitleDescStack } from "@components/elements";
import { cx, css } from "@panda/css";
import { styled } from "@panda/jsx";
import { flex } from "@panda/patterns";

import { DownloadCardCta } from "./DownloadCard.molecule";
import { downloadCardStyles } from "./DownloadCard.style";

const downloadFooterCardStyles = cx(
	css({
		border: "token(spacing.eds.dimension.1) solid token(colors.eds.palette.transparent.light.005)",
		backgroundColor: "eds.palette.transparent.light.005",
		backdropFilter: "var(--effect-material-blur, blur(50px))",
		borderRadius: "eds.dimension.24",
		paddingBlock: "eds.dimension.32",
		paddingInline: "eds.dimension.32",
	}),
	flex({
		justifyContent: "space-between",
		gap: "eds.dimension.32",
		sm: {
			alignItems: "center",
		},
		smDown: {
			flexDir: "column",
			alignItems: "flex-start",
		},
	}),
);

export function DownloadFooterCard({ card }: { card: DownloadCardFragment }): React.JSX.Element {
	return (
		<div className={cx("download-card-footer", downloadCardStyles, downloadFooterCardStyles)}>
			<TitleDescStack
				title={{ ...card.title, variant: "headingMD", as: "span" }}
				description={{ ...card.description, variant: "paragraphSM" }}
				stack={{ gap: "eds.dimension.8" }}
			/>
			{card.cta ? (
				<styled.div minWidth="fit-content">{DownloadCardCta({ cta: card.cta, buttonSize: "lg" })}</styled.div>
			) : undefined}
		</div>
	);
}
